import axios from "axios";
import { keyAccessToken, keyUserId } from "../../assets/js/SessionStorageNames";

// Función para obtener headers dinámicamente en cada llamada
const getAuthHeaders = () => {
    const accessToken = localStorage.getItem(keyAccessToken);
    const userId = localStorage.getItem(keyUserId);
    
    // Validar que el userId sea válido (no null, undefined, o cadena vacía)
    // También verificar que no sea la cadena literal "null" o "undefined"
    const validUserId = userId && 
                       userId.trim() !== '' && 
                       userId !== 'null' && 
                       userId !== 'undefined' ? userId.trim() : null;
    
    const headers = {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": accessToken,
    };
    
    // Agregar x-user-id (el servidor lo validará)
    // Si no es válido, el servidor devolverá un error descriptivo
    headers["x-user-id"] = validUserId || '';
    
    // Log de advertencia si el userId no es válido (para debugging)
    if (!validUserId) {
        console.warn('Warning: x-user-id puede no ser válido. Valor encontrado:', userId);
    }
    
    return headers;
};

export const api = {
  get: (url, params) => {
    const headers = getAuthHeaders();
    return axios.get(url, {
      headers,
      ...params,
    });
  },
  post: (url, data) => {
    const headers = getAuthHeaders();
    return axios.post(url, data, {
      headers,
    });
  },
  put: (url, data) => {
    const headers = getAuthHeaders();
    return axios.put(url, data, {
      headers,
    });
  },
  patch: (url, data) => {
    const headers = getAuthHeaders();
    return axios.patch(url, data, {
      headers,
    });
  },
  delete: (url) => {
    const headers = getAuthHeaders();
    return axios.delete(url, {
      headers,
    });
  },
};